module.exports = __webpack_public_path__ + "img/drop-down.8235196b.svg";